export const GET_WEB_STATS = 'GET_WEB_STATS';
